module.exports = __webpack_public_path__ + "static/media/DC_F_Embroidery_Bicocca_White_Bordeaux.3aaec2aa.png";